import { useDuckQuery } from '../../../../duckDB/hooks/useDuckQuery';
import { formattedDateColumn } from '../../../../duckDB/utils/formattedDateColumn';
import { TableViewData } from './types';

export const useTableViewData = (isDataLoading: boolean) => {
  const { data, isLoading } = useDuckQuery<TableViewData>(
    `
    SELECT 
    scan_id as id,
    ranch_name as ranchName,
    block_name as blockName,
    ${formattedDateColumn('scan_date')} AS scanDate,
    filtered_cluster_count as filteredClusterCount,
    variety_id as varietyId
    FROM cluster_report_table
    ORDER BY scan_date ASC, ranch_name ASC, block_name ASC
    `,
    isDataLoading
  );

  return { data, isLoading: isLoading };
};
